// components/FirstPage/index.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import useDeviceType from '../useDeviceType';  // Updated import path to match App.js structure
import compassImage from '../../assets/boussole.png';
import cartoonBubble from '../../assets/cartoon.png';
import {
  Container,
  TextContainer,
  Title,
  Subtitle,
  BottomActionsContainer,
  StyledText,
  ContentWrapper,
  PrimaryButton,
  LogoImage,
  SpeechBubbleContainer,
  SpeechBubbleImage,
  SpeechBubbleText,
  TextButton
} from './styles';

const FirstPage = () => {
  const { isMobile } = useDeviceType();  // Using the same hook as App.js
  const navigate = useNavigate();

  const handleCreateAccount = () => {
    navigate('/gender-selection');
  };

  const handleExistingAccount = () => {
    navigate('/login');
  };

  return (
    <Container>
      <ContentWrapper>
          <LogoImage src={compassImage} alt="Compass Logo" />

        <TextContainer>
                  <Title isMobile={isMobile}>
                    Le meilleur de<br />
                    l'orientation avec l'IA!
                  </Title>
                  <Subtitle isMobile={isMobile}>
                    Trouver les informations sur l'orientation<br />
                     n'a jamais été aussi facile.
                  </Subtitle>
                </TextContainer>
          <PrimaryButton onClick={handleCreateAccount}>
                    C'est parti!
                  </PrimaryButton>
                  <BottomActionsContainer>
                    <StyledText>Déjà inscrit?</StyledText>
                    <TextButton onClick={handleExistingAccount}>
                      Se connecter
                    </TextButton>
                  </BottomActionsContainer>
      </ContentWrapper>
    </Container>
  );
};

export default FirstPage;
